import { Params } from '@angular/router';

export interface TagInfo {
  id: string;
  name: string;
  type: string;
}

export function getTagInfoFromUrlParams(params: Params): TagInfo[] {
  if (!params['tags']) {
    return [];
  }
  return params['tags'].split(',').map((tag: string) => {
    const [id, name, type] = tag.split(':');
    return { id, name, type };
  });
}
